import {
  S3ASSETLIST_FETCHITEMS_LOAD,
  S3ASSETLIST_FETCHITEMS_SUCCEED,
  S3ASSETLIST_FETCHITEMS_FAIL,
  S3ASSETLIST_CHANGETABLE_CHANGE,
  S3ASSETLIST_SEARCHTABLE_EDIT,
  S3ASSETLIST_SEARCHTABLE_SEARCH,
  S3ASSETLIST_UPLOADITEM_LOAD,
  S3ASSETLIST_UPLOADITEM_SUCCEED,
  S3ASSETLIST_UPLOADITEM_FAIL,
  S3ASSETLIST_DELETEITEM_LOAD,
  S3ASSETLIST_DELETEITEM_SUCCEED,
  S3ASSETLIST_DELETEITEM_FAIL,
  S3ASSETLIST_CREATEFOLDER_LOAD,
  S3ASSETLIST_CREATEFOLDER_SUCCEED,
  S3ASSETLIST_CREATEFOLDER_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case S3ASSETLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case S3ASSETLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
        currentFolder: action.currentFolder || '',
      }
    case S3ASSETLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case S3ASSETLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case S3ASSETLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case S3ASSETLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    case S3ASSETLIST_UPLOADITEM_LOAD:
      return {
        ...state,
        isUploadItemLoading: true,
        uploadItemError: null,
      }
    case S3ASSETLIST_UPLOADITEM_SUCCEED:
      return {
        ...state,
        isUploadItemLoading: false,
        uploadedItem: action.item,
      }
    case S3ASSETLIST_UPLOADITEM_FAIL:
      return {
        ...state,
        isUploadItemLoading: false,
        uploadItemError: action.uploadItemError,
      }
    case S3ASSETLIST_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        deleteItemError: null,
      }
    case S3ASSETLIST_DELETEITEM_SUCCEED:
      return {
        ...state,
        isDeleteItemLoading: false,
        // Filter by key (full path) or by name (just filename) for backwards compatibility
        items: state.items ? state.items.filter(item => {
          const itemKey = item.key || ''
          const itemName = item.name || ''
          return itemKey !== action.key && 
                 itemName !== action.key && 
                 !itemKey.endsWith('/' + action.key) &&
                 !itemKey.endsWith(action.key)
        }) : [],
      }
    case S3ASSETLIST_DELETEITEM_FAIL:
      return {
        ...state,
        isDeleteItemLoading: false,
        deleteItemError: action.deleteItemError,
      }
    case S3ASSETLIST_CREATEFOLDER_LOAD:
      return {
        ...state,
        isCreateFolderLoading: true,
        createFolderError: null,
      }
    case S3ASSETLIST_CREATEFOLDER_SUCCEED:
      return {
        ...state,
        isCreateFolderLoading: false,
      }
    case S3ASSETLIST_CREATEFOLDER_FAIL:
      return {
        ...state,
        isCreateFolderLoading: false,
        createFolderError: action.createFolderError,
      }
    default:
      return state
  }
}

